// Removed react-router-dom Import
import { useTranslation } from 'react-i18next';

export const ValueComparisonSection = () => {
  const { t } = useTranslation();

  const comparisonData = [
    {
      feature: t('comparison.rows.inalterabilidad.name'),
      '4tlayer': t('comparison.rows.inalterabilidad.4tlayer'),
      pdf: t('comparison.rows.inalterabilidad.pdf'),
      fisico: t('comparison.rows.inalterabilidad.physical')
    },
    {
      feature: t('comparison.rows.verificacion.name'),
      '4tlayer': t('comparison.rows.verificacion.4tlayer'),
      pdf: t('comparison.rows.verificacion.pdf'),
      fisico: t('comparison.rows.verificacion.physical')
    },
    {
      feature: t('comparison.rows.permanencia.name'),
      '4tlayer': t('comparison.rows.permanencia.4tlayer'),
      pdf: t('comparison.rows.permanencia.pdf'),
      fisico: t('comparison.rows.permanencia.physical')
    },
    {
      feature: t('comparison.rows.costo.name'),
      '4tlayer': t('comparison.rows.costo.4tlayer'),
      pdf: t('comparison.rows.costo.pdf'),
      fisico: t('comparison.rows.costo.physical')
    },
    {
      feature: t('comparison.rows.soporte.name'),
      '4tlayer': t('comparison.rows.soporte.4tlayer'),
      pdf: t('comparison.rows.soporte.pdf'),
      fisico: t('comparison.rows.soporte.physical')
    }
  ];

  return (
    <section id="validacion" className="py-12 lg:py-24 bg-gray-50 border-y border-gray-100 relative overflow-hidden">
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-brand-electric-blue/5 rounded-full blur-3xl translate-x-1/2 translate-y-1/2 -z-0"></div>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">

        <div className="text-center mb-16 animate-on-scroll">
          <h2 className="font-audiowide text-3xl sm:text-4xl text-[#111111] mb-6">{t('comparison.title')}</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-brand-electric-blue to-brand-neon-green mx-auto rounded-full"></div>
          <p className="font-montserrat text-[#333333] mt-6 max-w-2xl mx-auto font-semibold">
            {t('comparison.subtitle')}
          </p>
        </div>

        {/* Desktop Table View (Hidden on mobile) */}
        <div className="hidden md:block bg-white rounded-2xl border border-[#E5E7EB] shadow-sm overflow-hidden animate-on-scroll">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-gray-50 border-b border-[#E5E7EB]">
                <th className="py-6 px-6 font-audiowide text-[#111111] w-1/4">{t('comparison.headers.feature')}</th>
                <th className="py-6 px-6 font-audiowide text-brand-electric-blue w-1/4 bg-blue-50/50 text-left">{t('comparison.headers.4tlayer')}</th>
                <th className="py-6 px-6 font-audiowide text-[#555555] w-1/4 text-left">{t('comparison.headers.pdf')}</th>
                <th className="py-6 px-6 font-audiowide text-[#555555] w-1/4 text-left">{t('comparison.headers.physical')}</th>
              </tr>
            </thead>
            <tbody className="font-montserrat font-medium text-[#333333]">
              {comparisonData.map((row, idx) => (
                <tr key={idx} className="border-b border-[#E5E7EB] hover:bg-gray-50/50 transition-colors last:border-0">
                  <td className="py-5 px-6 font-semibold">{row.feature}</td>
                  <td className="py-5 px-6 bg-blue-50/30 text-left">
                    <div className="flex items-center gap-2">
                      <i className="fas fa-check-circle text-brand-electric-blue"></i>
                      <span className="text-brand-electric-blue font-bold">{row['4tlayer']}</span>
                    </div>
                  </td>
                  <td className="py-5 px-6 text-[#666666] text-left">
                    <div className="flex items-center gap-2">
                       <i className="fas fa-minus text-[#9CA3AF]"></i>
                       <span>{row.pdf}</span>
                    </div>
                  </td>
                  <td className="py-5 px-6 text-[#666666] text-left">
                    <div className="flex items-center gap-2">
                      <i className="fas fa-times text-[#9CA3AF]"></i>
                      <span>{row.fisico}</span>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Mobile Table View (Shown only on mobile) */}
        <div className="md:hidden overflow-x-auto -mx-4 px-4 pb-4 select-none">
          <div className="min-w-[420px] bg-white rounded-2xl border border-gray-100 shadow-sm overflow-hidden animate-on-scroll">
            <table className="w-full text-left border-collapse table-fixed">
              <thead>
                <tr className="bg-gray-50 border-b border-gray-100">
                  <th className="py-4 px-3 font-audiowide text-[10px] text-[#111111] w-[28%]">{t('comparison.headers.feature')}</th>
                  <th className="py-4 px-2 font-audiowide text-brand-electric-blue w-[24%] bg-blue-50/50 text-left text-[10px]">{t('comparison.headers.4tlayer')}</th>
                  <th className="py-4 px-2 font-audiowide text-[#555555] w-[24%] text-left text-[10px]">{t('comparison.headers.pdf')}</th>
                  <th className="py-4 px-2 font-audiowide text-[#555555] w-[24%] text-left text-[10px]">{t('comparison.headers.physical').split(' ')[1] || t('comparison.headers.physical')}</th>
                </tr>
              </thead>
              <tbody className="font-montserrat font-semibold text-[#333333] text-[10px]">
                {comparisonData.map((row, idx) => (
                  <tr key={idx} className="border-b border-gray-50 last:border-0 hover:bg-gray-50/30 transition-colors">
                    <td className="py-3 px-3 leading-tight font-bold text-[11px]">{row.feature}</td>
                    <td className="py-3 px-2 bg-blue-50/20 text-left">
                      <div className="flex flex-col items-start gap-0.5">
                        <i className="fas fa-check-circle text-brand-electric-blue text-sm"></i>
                        <span className="text-brand-electric-blue text-[8px] leading-tight text-left">{row['4tlayer']}</span>
                      </div>
                    </td>
                    <td className="py-3 px-2 text-[#666666] text-left">
                      <div className="flex flex-col items-start gap-0.5 opacity-60">
                         <i className="fas fa-minus text-gray-300 text-[10px]"></i>
                         <span className="text-[8px] leading-tight text-left">{row.pdf}</span>
                      </div>
                    </td>
                    <td className="py-3 px-2 text-[#666666] text-left">
                      <div className="flex flex-col items-start gap-0.5 opacity-60">
                         <i className="fas fa-times text-gray-300 text-[10px]"></i>
                         <span className="text-[8px] leading-tight text-left">{row.fisico}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex items-center justify-center gap-2 mt-4 text-gray-400 text-[10px] animate-pulse">
            <i className="fas fa-arrows-alt-h"></i>
            <span>Desliza para ver más</span>
          </div>
        </div>


        <div className="mt-12 text-center animate-on-scroll">
          <a href="#contacto" className="inline-block px-10 py-4 rounded-lg bg-gradient-to-r from-brand-electric-blue to-brand-neon-green text-white font-montserrat font-semibold text-lg transition-transform hover:-translate-y-1 shadow-lg shadow-brand-neon-green/20">
            {t('comparison.cta')}
          </a>
        </div>
      </div>
    </section>
  );
};
